import { costBreakdownWidgetDataSelector } from "./costBreakdownWidgetDataSelector";
import { costBreakdownWidgetFrequencySelector } from "./costBreakdownWidgetFrequencySelector";
import { RootState } from "../../../../store";
import { calculateTotalCostTrend } from "../../../../../components/pages/utils/helpers/calculateTotalCostTrend";
import { buildingInProgressWidgetId } from "../../../thunks/widgets/utils/constants";
import { WidgetCosts } from "../../../utils/types/types";
import { getAverageDataByFrequency } from "../../../utils/helpers/costBreakdown/getAverageDataByFrequency";

export const costBreakdownWidgetCostsSelector = (
  state: RootState,
  widgetId?: string,
): WidgetCosts => {
  const widgetData = costBreakdownWidgetDataSelector(
    state,
    widgetId ?? buildingInProgressWidgetId,
  );
  const frequency = costBreakdownWidgetFrequencySelector(state, widgetId);

  const totalCost = +(widgetData?.total_cost ?? 0).toFixed(2);
  const previousPeriodTotalCost = +(
    widgetData?.previous_period_total_cost ?? 0
  ).toFixed(2);

  const totalCostTrend = calculateTotalCostTrend(
    totalCost,
    previousPeriodTotalCost,
  );

  const average = getAverageDataByFrequency(frequency, widgetData);

  return {
    total: {
      cost: totalCost,
      trend: previousPeriodTotalCost > 0 ? totalCostTrend : null,
      dateDetails: widgetData?.total_cost_date_details,
    },

    previousPeriodTotal: {
      cost: previousPeriodTotalCost,
      dateDetails: widgetData?.previous_period_cost_date_details,
    },

    average,

    liveUsageTotal: {
      cost: +(widgetData?.live_usage_total_cost ?? 0)?.toFixed(2),
    },
    forecasted_costs: widgetData?.forecasted_costs,
  };
};
